module.exports = __webpack_public_path__ + "img/pic_title_img1.5bcb19f7.png";